<template>
  <div class="bill-details" ref="container">
    <div class="nav acea-row">
      <div class="item" :class="types == 1 ? 'on' : ''" @click="changeTypes(1)">
        供灯中
      </div>
      <div class="item" :class="types == 2 ? 'on' : ''" @click="changeTypes(2)">
        已过期
      </div>
    </div>

  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">供灯信息</div>
          <div>
            累计供灯数：{{payCount}}
            <!-- 当前功德榜排名：￥0 -->
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="order in list" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle" style="color:#b37536;font-weight:bold">
            <!-- {{order.realName}}&nbsp;
            <span
              class="sign cart-color acea-row row-center-wrapper"
              >供灯中</span> -->
            <!-- 供灯过期时间：{{ order.createTime }}  -->
            <!-- 因缘寺寺 - 大雄宝殿（左边） -->
            {{order.cateDeviceName}}
          </div>
          <div class="font-color-red" v-if="types==1">
            <span class="sign cart-color acea-row row-center-wrapper">供灯中</span>
          </div>
        </div>
        <div class="totalPrice"  style="color:#b37536">
          【供灯编号】{{ order.orderId }}
        </div>
        <div class="totalPrice"  style="color:#b37536">
          【供灯时间】{{ order.payTime }}
        </div>
        <div class="totalPrice"  style="color:#b37536" v-if="order.lampSelectTime">
          【供灯期限】{{ order.lampSelectTime }}
        </div>
        <div class="totalPrice"  style="color:#b37536" v-if="order.realName">
          【功&nbsp;&nbsp;德&nbsp;&nbsp;主】{{order.realName}}
        </div>
        <div class="totalPrice"  style="color:#b37536">
          【供灯金额】<span class="money font-color-red">￥{{ order.payPrice }}</span>
        </div>
        
        
        
        <div class="totalPrice"  style="color:#b37536" v-if="order.code==1">
          【祈福类型】点亮【平安健康】祈福灯
        </div>
        
        <div class="totalPrice"  style="color:#b37536" v-if="order.code==1">
          【祈&nbsp;&nbsp;福&nbsp;&nbsp;语】{{ order.mark }}
        </div>
        
        <div class="bottom acea-row row-right row-middle">
          <template>
            <div
              class="bnt bg-color-red"
              @click="showOrderInfo(order)">
              祈福详情
            </div>
            <div
              v-if="types==1&&order.lampSelectTime"
              class="bnt bg-color-red"
              @click="lightUpLamp(order.orderId)">
              立即寻灯
            </div>
          </template>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
    <!-- <Loading :loaded="loaded" :loading="loading"></Loading> -->
    <van-popup v-model:show="show">内容</van-popup>
  </div>
</template>
<script>
import { getCommissionInfo } from "../../api/user";
import { getOrderData, getOrderList } from "@api/order";
import { lightUpLamp } from "@api/lamp";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";

export default {
  name: "UserBill",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      payCount:0,
      types: "",
      where: {
        page: 1,
        limit: 5
      },
      list: [],
      loaded: false,
      loading: false
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    "$route.params.types": function(newVal) {
      let that = this;
      if (newVal != undefined) {
        that.types = newVal;
        that.list = [];
        that.where.page = 1;
        that.loaded = false;
        that.loading = false;
        that.getIndex();
      }
    },
    types: function() {
      this.getIndex();
    }
  },
  mounted: function() {
    let that = this;
    that.types = that.$route.params.types;
    that.getIndex();
    that.getUserInfo();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getIndex();
    });
  },
  filters: {
    handleText(value) {
      if (!value) return ''
      if (value.length > 12) {
        return value.slice(0, 100) + '...'
      }
      return value
    }

  },
  methods: {
    getUserInfo(){
          this.$store.dispatch("USERINFO").then((res) => {
                this.payCount=res.payCount
          });
    },
    showOrderInfo: function(order) {
      //目前只是拿该字段临时来使用
      if(order.code==1){
          order.code=0;
      }else{
         order.code = 1;
      }
    },
    changeTypes: function(val) {
      if (val != this.types) {
        this.types = val;
        this.list = [];
        this.where.page = 1;
        this.loaded = false;
        this.loading = false;
      }
    },
    getIndex: function() {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      let page=that.where.page
      let limit=that.where.limit
      let type=that.types
      let params={page,limit,type};
      getOrderList(params).then(res => {
            that.loading = false;
            that.loaded = res.data.storeOrderQueryVo.length < that.where.limit;
            that.where.page = that.where.page + 1;
            that.list.push.apply(that.list, res.data.storeOrderQueryVo);
      });
    },
    lightUpLamp: function(orderId) {
        this.$dialog.confirm({
          mes: '您确定立即寻灯吗？',
          opts: () => {
            lightUpLamp(orderId).then(
              res => {
                this.$dialog.message("操作成功");
              },
              err => {
                this.$dialog.message(err.msg);
              }
            );
          }
        });
        
    }

  }
};
</script>
